export default __webpack_public_path__ + "static/media/cameragot-screenshot-02.9c46804f.png";